import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const ISROIndustrialTour2026 = () => {
    const tourImages = [
        "2.png",
        "3.png",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        Industrial Tour to Indian Space Research Organisation (ISRO) – April 16, 2026
                                    </h2>

                                    <div className='py-2'>
                                        <p>
                                            An industrial tour to ISRO was organized for B.Tech 2nd-year students on April 16, 2026. The visit provided students with an opportunity to understand India’s space technology and research environment.
                                        </p>

                                        <p>
                                            During the tour, students were introduced to real-world applications of engineering concepts. ISRO experts explained ongoing projects, satellite launches, and advancements in space science.
                                        </p>

                                        <p>
                                            The visit helped students connect their academic knowledge with practical implementation and offered insight into working in a professional research organization.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {tourImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/ISRO-Industrial-Tour-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/ISRO-Industrial-Tour-2026/${img}`}
                                                            alt={`ISRO Industrial Tour 2026 Image ${index + 1}`}
                                                            className="img-responsive center-block rounded sixteen-nine"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ISROIndustrialTour2026;